import React from "react";
import PolicyLayout from "../PolicyLayout";

const UserDataDeletionPolicy: React.FC = () => {
  const deletionSections = [
    {
      title: "1. Right to Request User Data Deletion",
      content:
        "Users may request deletion of their personal data at any time. We respect your right to privacy, transparency, and control over your information.",
    },
    {
      title: "2. How to Request User Data Deletion",
      list: [
        `Send an email to ${import.meta.env.VITE_COMPANY_EMAIL}`,
        "Use the subject line: “User Data Deletion Request”",
        "Send the request from your registered mobile number or email address",
      ],
    },
    {
      title: "3. Verification Process",
      content:
        "To ensure data security and prevent unauthorized requests, we verify the identity of the requester before processing any data deletion request.",
    },
    {
      title: "4. User Data That Will Be Deleted or Anonymized",
      list: [
        "User profile details",
        "Registered phone number",
        "Email address",
        "PAN and other personal identification information",
      ],
    },
    {
      title: "5. Legal & Regulatory Data Retention",
      content:
        "Certain user data may be retained where required under applicable laws such as KYC, AML, or other regulatory and compliance obligations.",
    },
    {
      title: "6. Secure Retention & Final Deletion",
      content:
        "Any data required to be retained for legal or regulatory purposes will be securely stored and permanently deleted once the applicable retention period expires.",
    },
    {
      title: "7. Contact Information",
      list: [
        `Email: ${import.meta.env.VITE_COMPANY_EMAIL}`,
      ],
    },
  ];

  return (
    <PolicyLayout 
      title="Data Deletion Policy" 
      subtitle={`Learn how you can request deletion of your personal data from ${import.meta.env.VITE_COMPANY_NAME}. We empower you with full control over your digital identity.`}
      badge="User Control 🔐"
    >
      {deletionSections.map((section, idx) => (
        <div key={idx} className="space-y-6">
          <h2 className="text-3xl font-black text-[#0F172A] tracking-tight">
            {section.title}
          </h2>

          {section.content && (
            <p className="text-[var(--text-secondary)] text-lg leading-relaxed font-medium whitespace-pre-line">
              {section.content}
            </p>
          )}
          
          {section.list && (
            <ul className="space-y-4">
              {section.list.map((li, i) => (
                <li key={i} className="flex items-start gap-3 text-[var(--text-secondary)] text-lg font-medium">
                  <span className="w-1.5 h-1.5 rounded-full bg-[var(--primary)] mt-2.5 flex-shrink-0" />
                  {li}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </PolicyLayout>
  );
};

export default UserDataDeletionPolicy;
